import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatMapeoErpService {
  constructor() {
    this.mapeoErps = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatMapeoErp:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatMapeoErp después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatMapeoErp/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allMapeoErps = response.data || [];
      this.mapeoErps = allMapeoErps.filter(mapeoErp => mapeoErp.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('MapeoErps cargados:', this.mapeoErps.length, 'de', allMapeoErps.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Mapeos ERP cargados:', this.mapeoErps.length);
      
      return {
        success: true,
        data: this.mapeoErps,
        message: 'Mapeos ERP cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar Mapeos ERP:', error);
      this.error = error.message;
      this.mapeoErps = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(mapeoErpData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...mapeoErpData,
        EmpresaId: selectedEmpresa?.EmpresaId || mapeoErpData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatMapeoErp/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Mapeo ERP guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar Mapeo ERP:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar Mapeo ERP'
      };
    }
  }

  async borrar(mapeoErpData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...mapeoErpData,
        EmpresaId: selectedEmpresa?.EmpresaId || mapeoErpData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatMapeoErp/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Mapeo ERP eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar Mapeo ERP:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar Mapeo ERP'
      };
    }
  }

  async lectura(erpId, objetoId, campoGestion360) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatMapeoErp/lectura'), {
        ErpId: erpId,
        ObjetoId: objetoId,
        CampoGestion360: campoGestion360,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer Mapeo ERP:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer Mapeo ERP'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatMapeoErp/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `mapeos_erp_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar Mapeos ERP:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar Mapeos ERP'
      };
    }
  }
}

export default CatMapeoErpService;
